import request from '@/utils/request'

// 卡卷列表
export function getMembershipList(params) {
  return request({
    url: '/memberProducts/server/productsList' ,
    method: 'get',
    params
  })
}

export function getPriceList(params){
  return request({
    url: '/memberLevel/server/selectionLevel' ,
    method: 'get',
    params
  })
}

export function testApi(data) {
  return request({
    url: `member/alipay?productId=${data.productId}&url=${data.url}`,
    method: 'get'
  })
}


export function getPayment(data) {
  return request({
    url: `/system/informationsheet/payMember?productId=${data.productId}`,
    method: 'get'
  })
}
export function getWxPay(data) {
  return request({
    url: `/member/weChatPay?productId=${data}`,
    method: 'get'
  })
}

export function getPaymentMethod(){
  return request({
    url: `/payConfig/server/getPayConfig`,
    method: 'get'
  })
}

export function getPublicPay(data) {
  return request({
    url: `/member/corporateTransfer?productId=${data.productId}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/accept/purchase-membership/index.js